import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import ContentContainer from "~/components/layout/ContentContainer";

import transition from "~/utilities/transition";

import SubNavLinks from "~/components/SubNav/SubNavLinks";
import SubNavCards from "~/components/SubNav/SubNavCards";
import IconLink from "~/components/links/IconLink";

const Wrapper = styled.div`
    ${transition({}, "opacity", "visibility")};
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    background-color: ${({ theme }) => theme.palette.whiteOverlay};
    padding: 30px 25px 50px;
    opacity: ${({ isOpen }) => (isOpen ? `1` : `0`)};
    visibility: ${({ isOpen }) => (isOpen ? `visible` : `hidden`)};
    z-index: ${({ theme }) => theme.zIndex.subNav};
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        display: block;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        padding: 30px 50px 50px;
    }
`;

const MainSubNav = ({
    cards = [],
    links = [],
    iconLinks = [],
    isOpen = false,
    numberOfColumns,
    tagLabel = null,
    tagRef = null,
    type,
}) => (
    <Wrapper {...{ isOpen }}>
        <ContentContainer noPaddingReset>
            {type === "cards" ? (
                <SubNavCards {...{ cards, tagLabel, tagRef }} />
            ) : type === "iconLinks" ? (
                <IconLink {...{ iconLinks, tagLabel, tagRef }} />
            ) : (
                <SubNavLinks
                    {...{ links, numberOfColumns, tagLabel, tagRef }}
                />
            )}
        </ContentContainer>
    </Wrapper>
);

MainSubNav.propTypes = {
    type: PropTypes.oneOf(["links", "cards", "iconLinks", "noSubNavigation"])
        .isRequired,
    numberOfColumns: PropTypes.number.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            linkLabel: PropTypes.string.isRequired,
            linkUrl: PropTypes.string.isRequired,
            subNavigation: PropTypes.arrayOf(
                PropTypes.shape({
                    linkUrl: PropTypes.string.isRequired,
                    linkLabel: PropTypes.string.isRequired,
                }),
            ),
        }),
    ),
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            logo: PropTypes.shape({
                sourceUrl: PropTypes.string,
                altText: PropTypes.string,
                title: PropTypes.string.isRequired,
            }),
            logoBackgroundColor: PropTypes.string,
            title: PropTypes.string,
            subTitle: PropTypes.string,
            productsImage: PropTypes.shape({
                sourceUrl: PropTypes.string,
                altText: PropTypes.string,
                title: PropTypes.string.isRequired,
            }),
            buttonLabel: PropTypes.string,
            buttonUrl: PropTypes.string,
            additionalLinks: PropTypes.arrayOf(
                PropTypes.shape({
                    linkLabel: PropTypes.string.isRequired,
                    linkUrl: PropTypes.string.isRequired,
                }),
            ),
        }),
    ),
    iconLinks: PropTypes.arrayOf(
        PropTypes.shape({
            iconName: PropTypes.string,
            linkUrl: PropTypes.string.isRequired,
            linkLabel: PropTypes.string.isRequired,
        }),
    ),
    isOpen: PropTypes.bool,
    tagLabel: PropTypes.string,
    tagRef: PropTypes.object,
};

export default MainSubNav;
